import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Rechercher/Ajouter un Patient", -1)
const _hoisted_5 = {
  key: 0,
  class: "w-100 d-block d-md-flex align-items-center"
}
const _hoisted_6 = {
  key: 1,
  class: ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "pb-2 mt-4 default" }, "Informations sur le patient selectionné: ", -1)
const _hoisted_8 = { class: "container default" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user text-secondary mx-1" }, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user text-secondary mx-1" }, null, -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-address-book text-secondary mx-1" }, null, -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-address-book text-secondary mx-1" }, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days text-secondary mx-1" }, null, -1)
const _hoisted_24 = { class: "row border-bottom-dashed" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-person text-secondary mx-1" }, null, -1)
const _hoisted_27 = { class: "col" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days text-secondary mx-1" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mx-2 cursor-pointer",
  for: "patient"
}, " Confirmer le patient sélectionné ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-square" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mx-2 cursor-pointer",
  for: "patient"
}, " Confirmer le patient sélectionné ", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

import Modal from './Modal.vue';
import { computed, ref } from 'vue';
import VueMultiselect from 'vue-multiselect'
import { useClipboard, usePermission } from '@vueuse/core'
import IconCall from '@/components/icons/IconCall.vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toast-notification';

//Methods for Modals
const datas = "user,dossier";



export default /*#__PURE__*/_defineComponent({
  __name: 'AddTeleconsultation',
  props: {
    id: Number
},
  setup(__props) {

const dialogVisible = ref(false)
const moreInfo = ref(false)

const store = useStore();
const input = ref('');
const $toast = useToast();
const display = computed(() => store.state.composable.display);

const { text, isSupported, copy } = useClipboard()
const permissionRead = usePermission('clipboard-read')
const permissionWrite = usePermission('clipboard-write')

const viewCall = ref(false)

//Call option modal
function launchDemoModal() {
    dialogVisible.value = true
}



const router = useRouter();
const isLoading = ref(false);
const patientSelect = ref(false)

const find = ref([])
const searchData: [] | any = ref([])
function gotoTeleconsultationForm() {
    dialogVisible.value = false;
    //router.push({ name: 'AddTeleconsultation'});
    window.location.href = "/teleconsultations/create";
    viewCall.value = false;
}

const DataPatient = (find: "") => {
    isLoading.value = true;
    store.dispatch('patient/searchPatient', find);
    searchData.value = store.state.patient.patient;
    isLoading.value = false;
}

const OpenPhoneLink = (phone: string) => {
    window.open(`tel:${phone}`);
    gotoTeleconsultationForm();
}
const CopyLink = (urlPatient: string) => {
    copy(urlPatient)
    $toast.success('Le lien de la vidéo conférence a été copier avec succès', { position: "bottom-right" })
}


function SelectPatient(id: 0, associations: "") {

    store.dispatch('patient/fetchPatient', { id: id, associations: associations }).then(() => {
        gotoTeleconsultationForm();
    });

}

const confirmPatient = (patient: "") => {
    patientSelect.value = true
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary p-2 fw-bold teleconsultation-btn",
      onClick: launchDemoModal
    }, [
      _hoisted_1,
      _createTextVNode(" Nouvelle téléconsultation ")
    ]),
    _createVNode(Modal, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
      title: "Sélectionner un patient",
      bgcolor: "#172b4d",
      colorTitle: "white",
      notification: "true",
      width: "lg"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            datas
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_unref(VueMultiselect), {
                    modelValue: find.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((find).value = $event)),
                    options: searchData.value,
                    "preserve-search": true,
                    placeholder: "Rechercher un Patient",
                    label: "name",
                    "preselect-first": false,
                    loading: isLoading.value,
                    onSearchChange: DataPatient,
                    onSelect: _cache[1] || (_cache[1] = ($event: any) => (confirmPatient(find.value)))
                  }, null, 8, ["modelValue", "options", "loading"])
                ]))
              : _createCommentVNode("", true),
            (find.value.user_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", null, [
                          _hoisted_11,
                          _createTextVNode("Nom: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.nom), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", null, [
                          _hoisted_14,
                          _createTextVNode("Prenom: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.prenom), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", null, [
                          _hoisted_17,
                          _createTextVNode("Adresse: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.user_id), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", null, [
                          _hoisted_20,
                          _createTextVNode("Téléphone: "),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (OpenPhoneLink(find.value.telephone)))
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(find.value.telephone), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", null, [
                          _hoisted_23,
                          _createTextVNode("Date de Naissance: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.date_de_naissance), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("p", null, [
                          _hoisted_26,
                          _createTextVNode("Sexe: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.sexe), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("p", null, [
                          _hoisted_28,
                          _createTextVNode(" Age: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.age), 1)
                        ])
                      ])
                    ]),
                    (!patientSelect.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ((patientSelect.value = true), (viewCall.value = false))),
                          class: "form-check p-0 cursor-pointer my-2"
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['primary', "fa-regular fa-square-check"])
                          }),
                          _hoisted_29
                        ]))
                      : _createCommentVNode("", true),
                    (patientSelect.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (SelectPatient(find.value.user_id, datas), (patientSelect.value = false), (viewCall.value = true))),
                          class: "form-check p-0 cursor-pointer my-2"
                        }, _hoisted_32))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})